import { Box, Button, Typography } from "@material-ui/core";
import React from "react";

//? ============================================================================
//? LE BLOC VISIBLE D'UNE BARRIÈRE — posé le 16/09/2026.
//? ============================================================================
//? Il n'est jamais rendu en fonctionnement normal. S'il apparaît, un défaut vient
//? d'être CONTENU : ce n'est pas « géré », c'est un bug à ouvrir.
//?
//? LA LANGUE DE L'INTERFACE DE CE MODULE EST L'ANGLAIS — vérifié sur l'existant
//? (`EventAuth` : « Get Started Now », « Add your event name » ; `EventSetup` :
//? « Add the primary event details and publish your event »). Les textes ci-dessous
//? sont donc en anglais, et les commentaires restent en français comme dans le
//? reste du travail récent.
//?
//? CE QUE CHAQUE MESSAGE DOIT DIRE, et pourquoi ce composant ne porte aucun texte
//? par défaut : « Something went wrong » ne renseigne personne. Chaque zone passe
//? donc SON `title` et SON `message`, qui nomment ce qui a échoué, ce qui tient
//? encore, et par où sortir. Un défaut silencieux vaut mieux qu'un défaut mal
//? décrit : pas de repli générique ici.
//?
//? Les couleurs sont les valeurs littérales de `theme/palette.js` (`ERROR.dark`
//? `#B72136`, `ERROR.light` `#FFA48D`, `ERROR.lighter` `#FFE7D9`, `GREY[600]`
//? `#637381`) plutôt que des chemins `sx` (« error.dark »). MUI est ici en
//? `5.0.0-alpha.30` : on ne dépend pas de la résolution de thème d'une alpha pour
//? afficher un écran d'erreur — c'est précisément le moment où il faut que ça
//? s'affiche quoi qu'il arrive.
const ZoneError = ({ title, message, onRetry, retryLabel = "Try again", compact = false, children = null }) => {
  return (
    <Box
      className="ZoneError"
      role="alert"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: compact ? "6px" : "12px",
        padding: compact ? "12px 16px" : "24px",
        margin: compact ? 0 : "24px 0",
        borderRadius: "8px",
        border: "1px solid #FFA48D",
        backgroundColor: "#FFE7D9"
      }}>
      <Typography
        component="h2"
        sx={{
          color: "#B72136",
          fontSize: compact ? "14px" : "18px",
          fontWeight: 700,
          lineHeight: 1.4
        }}>
        {title}
      </Typography>

      <Typography
        sx={{
          color: "#637381",
          fontSize: compact ? "13px" : "15px",
          lineHeight: 1.6
        }}>
        {message}
      </Typography>

      <Box sx={{ display: "flex", flexWrap: "wrap", gap: "8px", marginTop: "4px" }}>
        {/* La sortie de la barrière. `onRetry` remet l'état de la barrière à zéro et
            REMONTE le sous-arbre — sans recharger la page. Voir le pavé
            d'`ErrorBoundary/index.js` : recharger ferait repasser par une
            évaluation de module dont le fragment a déjà été effacé. */}
        {onRetry && (
          <Button variant="contained" size={compact ? "small" : "medium"} onClick={onRetry} sx={{ boxShadow: "none" }}>
            {retryLabel}
          </Button>
        )}
        {children}
      </Box>
    </Box>
  );
};

export default ZoneError;
